    <template >
  <div >

  <div>
  <div class="formPosition">
    <template>

      <!--  classes em aue se tem discplinas  -->
      <v-container
        class="grey lighten-5"
      >
        <v-row no-gutters>
          <v-col >
            <strong>Disciplinas</strong>
            <br />

            <div class="text-center">

            </div>
          </v-col>

        </v-row>
      </v-container>
<v-row>
<v-col class="d-flex" cols="12" >
            <v-progress-linear v-if="progresso"
            color="green"
            indeterminate
            rounded
            height="3"
          ></v-progress-linear>
        </v-col>
        </v-row>
      <v-container>
        <v-row no-gutters>
          <v-col>
            <template
             >
              <v-container class="text-md-left">
                <v-row no-gutters>
                  <v-col>
                    <v-card class="d-flex flex-row mb-6" max-width="400" tile>
                      <v-list flat>
                        <v-subheader>você tem ({{unidades.length}}). clica para prosseguir

                        </v-subheader>
                        <v-list-item-group color="primary">
                          <v-list-item
                          v-for="item in unidades"
                            :key="item.pkAula"
                          >
                            <v-list-item-icon>
                            </v-list-item-icon>

                            <v-list-item-content color="primary" dark >
                              <v-list-item-title v-text="item.sumario" @click="assistirAula(item)"
                              ></v-list-item-title>
                               <v-list-item-subtitle v-text="item.unidade+' - aula '+  item.aula"></v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-container>
    </template>
  </div>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({
    unidades: [],
    progresso: false,
    loadcombUnidade: null,
    loadcombSumario: null,
    loadcombAula: null,
    editedItem: {
      controldisciplina: 0,
      unidade: '',
      pkUnidade: 0,
      sumario: '',
      pkSumario: 0,
      aula: '',
      pkAula: 0,
      anoacademico: 0,
      classe: ''
    }
  }),
  created () {
    this.loadUnidadeComb()
  },

  methods: {
    assistirAula (item) {
      this.$store.state.objaula = item

      this.$router.push('assistir-aula')
    },

    async loadUnidadeComb () {
      this.editedItem.unidade = null
      const discAnoAcademico = { anoacademico: this.$store.state.objDisciplina.idAno_Academico,
        controliddisciplina: this.$store.state.objDisciplina.controliddisciplina }

      try {
        this.unidades = await axios
          .post('/unidadefindAll', discAnoAcademico)
          .then(res => res.data)
      } catch (error) {
        this.isUpdating = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }
  }
}
</script>
